import React from 'react';
export function Sparkline({
  data,
  className = ''
}: {
  data: number[];
  className?: string;
}) {
  const width = 200;
  const height = 60;
  const padding = 4;
  const min = Math.min(...data);
  const max = Math.max(...data);
  const range = max - min;
  const points = data.map((value, index) => {
    const x = padding + index / (data.length - 1) * (width - padding * 2);
    const y = height - padding - (value - min) / range * (height - padding * 2);
    return `${x},${y}`;
  }).join(' ');
  return <svg width={width} height={height} className={className} data-id="element-55">
      <polyline points={points} fill="none" stroke="#facc15" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-56" />
    </svg>;
}